import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { VerticalContainer } from "../../../components/styled";
import ViagemForm from "../../../components/viagens/form";
import { registerViagem } from "../../../services/viagens";
import {
    LocalActions,
    MotoristaActions,
    VeiculoActions
} from "../../../store/utils";
export default function AddViagem(props) {
  const viagem = props.location.state;

  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    try {
      setLoading(true);
      console.log(values)
      console.log("acioando")
      await registerViagem(values);
    } catch (err) {
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <VerticalContainer>
      <div />
      <ViagemForm
        initialValues={viagem}
        onFinish={onFinish}
        error={error}
        setError={setError}
        loading={loading}
      />
    </VerticalContainer>
  );
}
